import {L,PERSISTENCE,U} from "./util.js";
import {get_active_video_resolution} from "./main.js";
import parallel from 'async-es/parallel';
import eachSeries from 'async-es/eachSeries';

let cached_devices = undefined;

export function list_media_devices(cb) {
 if(cached_devices) return cb(null,cached_devices);
 if(!navigator.mediaDevices) return cb(new Error('No media device support'));
 navigator.mediaDevices.enumerateDevices().then(r=>cb(null,cached_devices=r.reduce((p,c)=>{
  L.trace({kind:c.kind,label:c.label,id:c.deviceId},"media device found");
  p[c.kind] = Object.assign(p[c.kind]||{},{[c.deviceId]:c});
  return p;
 },{}))).catch(cb);
}

export function make_media_config(type,cb) {
 list_media_devices((e,dl)=>{
  if(e) return cb(e);
  const {adid,vdid} = PERSISTENCE.get({adid:undefined,vdid:undefined});
  const index=vdid&&dl.videoinput&&dl.videoinput[vdid]&&Object.keys(dl.videoinput).findIndex(d=>d==vdid);
  CAMERA.facingMode=index?'environment':'user';
  cb(null, Object.assign({},
   type.video&&dl.videoinput && {
    video: Object.assign({},
     get_active_video_resolution(),
     {deviceId:(vdid&&dl.videoinput&&dl.videoinput[vdid])?vdid:Object.keys(dl.videoinput)[0]},
     {facingMode: CAMERA.facingMode}
    )
   },
   type.audio&&dl.audioinput && {
    audio: Object.assign({deviceId:Object.keys(dl.audioinput)[0]},
     (U.browser.name==='Chrome')&&{
      advanced: ['EchoCancellation','ExperimentalEchoCancellation',
                 'AutoGainControl','NoiseSuppression',
                 'HighpassFilter','AudioMirroring'].map(x=>({[`goog${x}`]:{exact:true}})),
     },
     adid&&dl.audioinput[adid]&&{deviceId:adid}
    )
   }
  ) );
 });
}

export function get_configured_media(cnf,cb) {
 L.trace({config: cnf},"getting media with configuration");
 navigator.mediaDevices.getUserMedia(cnf).then((s)=>cb(null,s)).catch(cb);
}
const device_type={"Mic":"audio", "Camera":"video"};
export const MEDIA={
 localstream: null,
 muteinfo:{audio:false, video:false},
 error: function(e,type) {
  return {
  "NotAllowedError": `No permissions to access your ${type}, Please allow access to your ${type} .`,
  "PermissionDeniedError":`You have denied to access your ${type}. You will join the call without your ${device_type[type]}.`,
  "NotFoundError":`${type} cannot be found.`,
  "DevicesNotFoundError": `${type} cannot be found.`,
  "NotReadableError":`Your ${type} is not functional. Reboot may help resolve the issue.`,
  "TrackStartError": `${type} cannot be started. Reboot may help resolve the issue.`,
  "OverconstrainedError": `Invalid settings applied on your ${type}.`,
  "ConstraintNotSatisfiedError": `${type} error.`,
  "TypeError":`${type} cannot be started.`,
  "*": `Failed to detect ${type}.`
 }[e];
},
query_permissions: function(cb) {
 if(!navigator.permissions) return cb(null, {audio: false, video: false});
  parallel({
   audio: function(cb) {
    navigator.permissions.query({name: 'microphone'})
    .then((p) =>cb(null,p.state==="granted"),cb);
   },
   video: function(cb) {
    navigator.permissions.query({name: 'camera'})
    .then((p) =>cb(null,p.state==="granted"),cb);
   }
  },cb);
 },
 dummy: {
  video_track:null,
  audio: () => {
   let ctx = new AudioContext(), oscillator = ctx.createOscillator();
   let dst = oscillator.connect(ctx.createMediaStreamDestination());
   oscillator.start();
   return Object.assign(dst.stream.getAudioTracks()[0], {enabled: false});
  },
  video: () => {
   if(MEDIA.dummy.video_track) return MEDIA.dummy.video_track;
   var canvas = Object.assign(document.createElement("canvas"), {width: 640, height: 480});
   var ctx = canvas.getContext('2d');
   requestAnimationFrame(function draw(){
    ctx.fillStyle = 'rgb(34,51,34)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setTimeout(requestAnimationFrame(draw),1000);
   });
   MEDIA.dummy.video_track=canvas.captureStream(0.5).getVideoTracks()[0];
   return MEDIA.dummy.video_track;
  }
 }
};
export const SCREEN={
 is_on:false,
 stream:null,
 startcapture: function (cb) {
  var nav=null;
  if (navigator.getDisplayMedia) {
   nav=navigator.getDisplayMedia({video: {width:screen.width, height:screen.height}});
  } else if (navigator.mediaDevices.getDisplayMedia) {
   nav=navigator.mediaDevices.getDisplayMedia({video: {width:screen.width, height:screen.height}});
  } else {
   nav=navigator.mediaDevices.getUserMedia({video: {mediaSource: 'screen',width:screen.width, height:screen.height}});
  }
  nav.then(s=>cb(null,s)).catch(ex=>cb(ex));
 },
 stopcapturing: function unShareScreen() {
  SCREEN.stream&&SCREEN.stream.getTracks().forEach(t=>t.stop());
  SCREEN.stream=null;
 }
};

const tests = {
 "4K(UHD)": {
  width: 3840,
  height: 2160,
  ratio: "16:9",
  cq: "h"
 },
 "1080p(FHD)": {
  width: 1920,
  height: 1080,
  ratio: "16:9",
  cq: "h"
 },
 "UXGA": {
  width: 1600,
  height: 1200,
  ratio: "4:3",
  cq: "h"
 },
 "720p(HD)": {
  width: 1280,
  height: 720,
  ratio: "16:9",
  cq: "h"
 },
 "SVGA": {
  width: 800,
  height: 600,
  ratio: "4:3",
  cq: "h"
 },
 "VGA": {
  width: 640,
  height: 480,
  ratio: "4:3",
  cq: "m"
 },
 "360p(nHD)": {
  width: 640,
  height: 360,
  ratio: "16:9",
  cq: "m"
 },
 "CIF": {
  width: 352,
  height: 288,
  ratio: "4:3",
  cq: "l"
 },
 "QVGA": {
  width: 320,
  height: 240,
  ratio: "4:3",
  cq: "l"
 },
 "QCIF": {
  width: 176,
  height: 144,
  ratio: "4:3",
  cq: "l"
 },
 "QQVGA": {
  width: 160,
  height: 120,
  ratio: "4:3",
  cq: "l"
 },
 "QQQVGA": {
  width: 80,
  height: 60,
  ratio: "4:3",
  cq: "l"
 },
 "WTGQVGA": {
  width: 40,
  height: 30,
  ratio: "4:3",
  cq: "l"
 }
};

function get_quality(call_quality, first) {
 var resolutions =
 Object.keys(tests).filter(k=> {
                           return ((tests[k].cq==call_quality) && (tests[k].result));
                           });
 if(resolutions && resolutions.length) {
  return resolutions[first?0:(resolutions.length-1)];
 }
 return null;
}

export const CAMERA={
 facingMode: 'user',
 auto_resolution_map: {
  "0":"high",
  "1":"medium",
  "2":"low",
  "3":"vlow"
 },
 auto_settings: undefined,
 tests: tests,
 assign_auto_settings: function() {
  CAMERA.auto_settings = {
   high: {
    active: {res:get_quality("h",true),fps:24},
    bw:{dl:20,ul:10}
   },
   medium: {
    active: {res:get_quality("m",true),fps:12},
    bw:{dl:10,ul:5}
   },
   low: {
    active: {res:get_quality("l",true),fps:5},
    bw:{dl:2,ul:1}
   },
   vlow: {
    active: {res:get_quality("l",false),fps:5},
    bw:{dl:0.1,ul:0.1}
   }
  };
 },
 test: function(cb) {
  var resolutions=PERSISTENCE.get('passed_res');
  if(resolutions) {
   resolutions=resolutions.split("||");
   resolutions.forEach(r=>{
    tests[r].result=1;
   });
   CAMERA.assign_auto_settings();
   return cb(null,CAMERA.tests);
  }
  var stream=null;
  eachSeries(Object.values(CAMERA.tests),(t,cb)=>{
   let constraints = {
    audio:false,
    video: {
     width: {exact: t.width},
     height: {exact: t.height}
    }
   };
   if(stream) stream.getTracks().forEach(t=>t.stop());
   navigator.mediaDevices.getUserMedia(constraints).then((s)=>{
    t.result=1;
    stream=s;
    cb();
   }).catch((e)=>{
    L.trace({err: e, constraints:constraints},`Failed to get camera stream with constraints`);
    t.result=0;
    t.error=e.name;
    cb();
   });
  },e=>{
   if(e) return L.error({e}),cb(e);
   if(stream) stream.getTracks().forEach(t=>t.stop());
   //storing passed tests
   var passed=Object.keys(CAMERA.tests).filter(k=>!!CAMERA.tests[k].result).join("||");
   PERSISTENCE.put("passed_res", passed);
   CAMERA.assign_auto_settings();
   cb(null,CAMERA.tests);
  });
 }
};


/* vim:set ts=8 sw=1 expandtab: */
